<template>
    <v-app>
        <div v-if="show === true">
            <div v-if="$auth.user">

                <v-app-bar
                    class="header"
                >
                    <img :src="logo" :height="80" alt="Logo du magasin" style="margin-top: 3vh"/>

                    <v-spacer></v-spacer>

                    <span>Bonjour {{ $auth.user.nom }} {{ $auth.user.prenom }}</span>
                    <v-menu
                        left
                        bottom
                        offset-y
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-app-bar-nav-icon
                                v-bind="attrs"
                                v-on="on"
                            ></v-app-bar-nav-icon>
                        </template>

                        <v-list>
                            <v-list-item>
                                <v-list-item-title>
                                    <v-btn color="primary" @click="logout">Déconnexion</v-btn>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                </v-app-bar>

                <v-container class="conteneur">
                    <div class="contenu">
                        <router-view>

                        </router-view>
                    </div>

                </v-container>
            </div>
            <LoginForm v-else
                       :logo="logo"
                       :logo-mobile="logoMobile"
                       :marque="marque"
                       :errorMessage="errorMessage"
                       :depot-ventes="depotVentes"
                       :loadingList="loadingList"
                       :loadingForm="loadingForm"
                       :depot-vente="depotVente"
                       @submit="login"
            >

            </LoginForm>
            <v-container
                class="footer"
                fixed
                fluid
                style="padding: 0;"
            >
                <v-row justify="center" align="center">
                    <div class="d-inline-block mr-2">
                        © 2017 - {{ new Date().getFullYear() }}

                    </div>
                    <img :src="require('./assets/image/logo-webtroc_274x85.png')" class="logo-web-troc"/>
                </v-row>


            </v-container>

        </div>
    </v-app>
</template>

<script>
import LoginForm from './components/LoginForm'
import {Article, Configuration, Entete, Field, FieldOnglet, Ligne, LigneRetro, Retrocession, Stock} from "@/models";

export default {
    data() {
        return {
            errorMessage: '',
            depotVentes: [],
            depotVente: '',
            logo: '',
            logoMobile: '',
            favicon: '',
            loadingList: true,
            loadingForm: false,
            marque: false,
            show: false,
            urlManager: 'https://manager.web-troc.com'
        }
    },

    components: {
        LoginForm
    },
    methods: {
        login({email, idSoft, depotVente}) {
            this.loadingForm = true
            let promise = null
            if (this.marque === true) {
                promise = this.$auth.login(email, idSoft, this.depotVente.id, this.marque)
            } else {
                promise = this.$auth.login(email, idSoft, depotVente, this.marque)
            }

            promise.then(() => {
                if (!this.$auth.user) {
                    this.errorMessage = 'L\'authentification a échoué, veuillez réeessayer.'
                } else {
                    if (this.marque === false) {
                        this.logo = this.urlManager + '/medias/depots-vente/' + this.$auth.user.depotVente.id + '/logo/logo.png'
                        this.logoMobile = this.urlManager + '/medias/depots-vente/' + this.$auth.user.depotVente.id + '/logo/logo-mobile.png'
                        this.favicon = this.urlManager + '/medias/depots-vente/' + this.$auth.user.depotVente.id + '/logo/favicon.png'
                    }
                }

                this.loadingForm = false

                this.$router.push('/articles')
            })
        },
        logout() {
            Configuration.deleteAll()
            Entete.deleteAll()
            Article.deleteAll()
            Field.deleteAll()
            FieldOnglet.deleteAll()
            Ligne.deleteAll()
            LigneRetro.deleteAll()
            Retrocession.deleteAll()
            Stock.deleteAll()
            this.$auth.logout()
            this.$router.push('/')
            this.$auth.init()
        }
    },

    created() {
        this.$auth.isConnected()
        if (!this.$auth.user) {
            this.$auth.init()
                .then((data) => {
                    this.marque = data.marque
                    if (data.marque === false) {
                        this.depotVentes = data.magasins

                        if (this.$auth.user) {
                            this.logo = this.urlManager + '/medias/depots-vente/' + this.$auth.user.depotVente.id + '/logo/logo.png'
                            this.logoMobile = this.urlManager + '/medias/depots-vente/' + this.$auth.user.depotVente.id + '/logo/logo-mobile.png'
                            this.favicon = this.urlManager + '/medias/depots-vente/' + this.$auth.user.depotVente.id + '/logo/favicon.png'
                        }

                    } else {
                        this.depotVente = data.depotVente

                        this.logo = this.urlManager + '/medias/depots-vente/' + this.depotVente.id + '/logo/logo.png'
                        this.logoMobile = this.urlManager + '/medias/depots-vente/' + this.depotVente.id + '/logo/logo-mobile.png'
                        this.favicon = this.urlManager + '/medias/depots-vente/' + this.depotVente.id + '/logo/favicon.png'
                    }
                    this.show = true
                })
        } else {
            this.logo = this.urlManager + '/medias/depots-vente/' + this.$auth.user.depotVente.id + '/logo/logo.png'
            this.logoMobile = this.urlManager + '/medias/depots-vente/' + this.$auth.user.depotVente.id + '/logo/logo-mobile.png'
            this.favicon = this.urlManager + '/medias/depots-vente/' + this.$auth.user.depotVente.id + '/logo/favicon.png'
        }
    },

}
</script>
